import React from 'react';

const PublisherCard = ({ publisher }) => {
  return (
    <div className="publisher-card">
      <h3 className="publisher-name">{publisher.name}</h3>
      <a 
        href={publisher.website} 
        target="_blank" 
        rel="noopener noreferrer"
        className="publisher-link"
      >
        Visit {publisher.name} →
      </a>
    </div>
  );
};
/*
const PublisherCard = ({ publisher }) => {
  return (
    <div className="publisher-card">
      <h3 className="publisher-name">{publisher.name}</h3>
      <p className="publisher-description">{publisher.description}</p>
      <a 
        href={publisher.website} 
        target="_blank" 
        rel="noopener noreferrer"
        className="publisher-link"
      >
        Visit {publisher.name} →
      </a>
    </div>
  );
};
*/
export default PublisherCard;